
import React from 'react';
import { TranslationContent } from '../types';

interface WhyMeProps {
  t: TranslationContent['whyMe'];
}

const WhyMe: React.FC<WhyMeProps> = ({ t }) => {
  return (
    <section id="why-me" className="py-20 md:py-32 bg-slate-900 text-white overflow-hidden relative scroll-mt-20">
      <div className="absolute inset-0 opacity-10 pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-indigo-500 rounded-full blur-3xl animate-pulse" />
      </div>
      
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="text-center mb-20">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">{t.title}</h2>
          <div className="h-1.5 w-24 bg-indigo-500 mx-auto rounded-full" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-16 md:gap-12">
          {t.items.map((item, idx) => (
            <div key={idx} className="text-center px-4 group">
              <h3 className="text-xl font-bold mb-6 text-indigo-300 group-hover:text-indigo-200 transition-colors">{item.title}</h3>
              <p className="text-slate-300 leading-relaxed text-sm md:text-base">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyMe;